const apparelSizes = ["32", "34", "36", "38", "40", "42", "44"];
const alphaSizes = ["XS", "S", "M", "L", "XL"];
const denimSizes = ["24", "25", "26", "27", "28", "29", "30", "31", "32"];
const shoeSizes = ["36", "37", "38", "39", "40", "41"];

const rawProducts = [
  {
    id: 1,
    name: "Wool-blend checked midi shirt dress",
    category: "Dresses",
    price: "600.00",
    colors: ["Brown / Orange / Cream", "Forest / Navy"],
    size: apparelSizes,
    material: "50% wool, 45% recycled polyester, 5% other fibres",
    fit: "Close fit with a softly flared skirt",
    closure: "Button front and self-fabric belt",
    tags: ["new", "checked", "midi", "occasion"],
  },
  {
    id: 2,
    name: "Fitted jacket with fringe details and applicated pockets",
    category: "Coats & jackets",
    price: "525.00",
    colors: ["Forest Green", "Cherry Red"],
    size: apparelSizes,
    material: "Responsible wool-blend twill with recycled lining",
    fit: "Fitted, cropped silhouette",
    closure: "Button front",
    tags: ["new", "tailored", "fringe", "jacket"],
  },
  {
    id: 3,
    name: "Cotton barrel-leg jeans",
    category: "Denim",
    price: "295.00",
    colors: ["Mid Blue", "Deep Indigo"],
    size: denimSizes,
    material: "100% organic cotton denim",
    fit: "High rise with a curved barrel leg",
    closure: "Zip fly and button",
    tags: ["new", "denim", "barrel-leg", "organic cotton"],
  },
  {
    id: 4,
    name: "Dual-panel patchwork denim shorts",
    category: "Denim",
    price: "340.00",
    colors: ["Two-tone Blue", "Indigo / Ecru"],
    size: denimSizes,
    material: "100% cotton denim",
    fit: "High rise, relaxed bermuda length",
    closure: "Zip fly and button",
    tags: ["new", "patchwork", "denim", "shorts"],
  },
  {
    id: 5,
    name: "Abstract floral-print cropped bomber jacket",
    category: "Coats & jackets",
    price: "340.00",
    colors: ["Cobalt Floral", "Coral Floral"],
    size: alphaSizes,
    material: "Recycled satin with cotton-blend rib trims",
    fit: "Relaxed, cropped silhouette",
    closure: "Two-way metal zip",
    tags: ["new", "floral", "print", "bomber"],
  },
  {
    id: 6,
    name: "Printed mini dress",
    category: "Dresses",
    price: "375.00",
    colors: ["Ruby Flower", "Midnight Flower"],
    size: apparelSizes,
    material: "Responsibly sourced viscose satin",
    fit: "Fitted waist with a flared mini skirt",
    closure: "Concealed back zip",
    tags: ["new", "floral", "mini", "voluminous sleeves"],
  },
  {
    id: 7,
    name: "Mesh slip dress with floral embellishments",
    category: "Dresses",
    price: "445.00",
    colors: ["Black / Orchid", "Ink / Rose"],
    size: apparelSizes,
    material: "Recycled mesh with a viscose-blend slip lining",
    fit: "Slim midi silhouette",
    closure: "Side zip",
    tags: ["new", "occasion", "mesh", "embellished"],
  },
  {
    id: 8,
    name: "Floral-embellished tulle midi skirt",
    category: "Skirts",
    price: "405.00",
    colors: ["Black / Rose", "Midnight / Blue"],
    size: apparelSizes,
    material: "Recycled tulle with viscose lining",
    fit: "High rise with generous A-line volume",
    closure: "Concealed side zip",
    tags: ["new", "tulle", "floral", "midi"],
  },
  {
    id: 9,
    name: "Leopard-print color-block zip-up cardigan",
    category: "Sweaters & cardigans",
    price: "360.00",
    colors: ["Brown / Cobalt / Red", "Green / Pink"],
    size: alphaSizes,
    material: "Responsible wool and alpaca blend",
    fit: "Relaxed fit",
    closure: "Two-way metal zip",
    tags: ["new", "leopard", "color-block", "cardigan"],
  },
  {
    id: 10,
    name: "Knit cardigan with contrast trims",
    category: "Sweaters & cardigans",
    price: "375.00",
    colors: ["Lime / Lilac / Rust", "Navy / Cream"],
    size: alphaSizes,
    material: "Mohair and responsible wool blend",
    fit: "Boxy fit with dropped shoulders",
    closure: "Sculptural button front",
    tags: ["new", "knitwear", "contrast", "cardigan"],
  },
  {
    id: 11,
    name: "Graphic-intarsia cardigan",
    category: "Sweaters & cardigans",
    price: "360.00",
    colors: ["Midnight / Orange", "Cocoa / Pink"],
    size: alphaSizes,
    material: "Responsible merino wool blend",
    fit: "Relaxed fit with dropped shoulders",
    closure: "Button front",
    tags: ["new", "intarsia", "graphic", "knitwear"],
  },
  {
    id: 12,
    name: "Stud-embellished sweatshirt",
    category: "T-shirts & sweatshirts",
    price: "295.00",
    colors: ["Heather Grey / Silver", "Black / Gold"],
    size: alphaSizes,
    material: "100% organic cotton fleece",
    fit: "Relaxed fit",
    closure: "Pullover",
    tags: ["new", "studded", "organic cotton", "sweatshirt"],
  },
  {
    id: 13,
    name: "T-shirt with embellished collar",
    category: "T-shirts & sweatshirts",
    price: "225.00",
    colors: ["Ivory / Jewel", "Black / Crystal"],
    size: alphaSizes,
    material: "Organic cotton jersey with glass embellishments",
    fit: "Straight fit",
    closure: "Pullover with detachable collar",
    tags: ["new", "embellished", "t-shirt", "collar"],
  },
  {
    id: 14,
    name: "Printed wide-leg pants",
    category: "Pants & shorts",
    price: "295.00",
    colors: ["Moss Mosaic", "Ruby Mosaic"],
    size: apparelSizes,
    material: "Responsibly sourced viscose satin",
    fit: "High rise with a fluid wide leg",
    closure: "Concealed side zip",
    tags: ["new", "printed", "wide-leg", "satin"],
  },
  {
    id: 15,
    name: "Printed top with gathered neckline",
    category: "Tops & blouses",
    price: "265.00",
    colors: ["Moss Green", "Cobalt Blue"],
    size: apparelSizes,
    material: "Responsibly sourced viscose satin",
    fit: "Relaxed body with softly puffed sleeves",
    closure: "Back neck keyhole",
    tags: ["new", "gathered", "satin", "blouse"],
  },
  {
    id: 16,
    name: "Floral-print polo with bow buttons",
    category: "Tops & blouses",
    price: "250.00",
    colors: ["Navy Floral", "Cream Floral"],
    size: alphaSizes,
    material: "Organic cotton fine knit",
    fit: "Fitted body",
    closure: "Bow-shaped button placket",
    tags: ["new", "floral", "polo", "knit"],
  },
  {
    id: 17,
    name: "Floral jacquard flared mini skirt",
    category: "Skirts",
    price: "250.00",
    colors: ["Plum Floral", "Emerald Floral"],
    size: apparelSizes,
    material: "Recycled floral jacquard",
    fit: "High rise with a flared mini shape",
    closure: "Concealed back zip",
    tags: ["new", "jacquard", "floral", "mini"],
  },
  {
    id: 18,
    name: "Striped T-shirt with statement brooch detail",
    category: "T-shirts & sweatshirts",
    price: "180.00",
    colors: ["Navy / Ecru / Red", "Green / White"],
    size: alphaSizes,
    material: "100% organic cotton jersey",
    fit: "Relaxed straight fit",
    closure: "Pullover with detachable brooch",
    tags: ["new", "striped", "brooch", "t-shirt"],
  },
  {
    id: 19,
    name: "Polka-dot jacquard knit polo",
    category: "Tops & blouses",
    price: "225.00",
    colors: ["Chocolate / Cream", "Green / Lilac"],
    size: alphaSizes,
    material: "Responsible viscose-blend jacquard knit",
    fit: "Close fit",
    closure: "Button placket",
    tags: ["new", "polka-dot", "jacquard", "polo"],
  },
  {
    id: 20,
    name: "Checked wool-blend shorts",
    category: "Pants & shorts",
    price: "295.00",
    colors: ["Camel Check", "Grey Check"],
    size: apparelSizes,
    material: "Responsible wool-blend suiting",
    fit: "High rise, tailored bermuda length",
    closure: "Hook, button and zip fly",
    tags: ["new", "checked", "tailored", "shorts"],
  },
  {
    id: 21,
    name: "Draped wrap top with V-neck",
    category: "Tops & blouses",
    price: "250.00",
    colors: ["Tomato Red", "Midnight Blue"],
    size: apparelSizes,
    material: "Recycled matte crepe",
    fit: "Fitted wrap silhouette",
    closure: "Concealed side zip",
    tags: ["new", "draped", "wrap", "evening"],
  },
  {
    id: 22,
    name: "Bias-cut midi skirt with back slit",
    category: "Skirts",
    price: "250.00",
    colors: ["Electric Blue", "Mulberry"],
    size: apparelSizes,
    material: "Responsibly sourced viscose satin",
    fit: "Slim bias cut",
    closure: "Elasticated waist",
    tags: ["new", "bias-cut", "midi", "satin"],
  },
  {
    id: 23,
    name: "Double-breasted blazer with underarm zip detail",
    category: "Coats & jackets",
    price: "525.00",
    colors: ["Aubergine", "Cobalt Blue"],
    size: apparelSizes,
    material: "Responsible wool-blend tailoring",
    fit: "Oversized, longline silhouette",
    closure: "Double-breasted button front",
    tags: ["new", "blazer", "tailored", "zip detail"],
  },
  {
    id: 24,
    name: "Checked cape-like jacket with faux leather trims",
    category: "Coats & jackets",
    price: "420.00",
    colors: ["Camel Check", "Green Check"],
    size: alphaSizes,
    material: "Responsible wool blend with recycled faux-leather trims",
    fit: "Cropped cape silhouette",
    closure: "Concealed snap front",
    tags: ["new", "cape", "checked", "outerwear"],
  },
  {
    id: 25,
    name: "Gloss leather top-handle bag",
    category: "Bags",
    price: "525.00",
    colors: ["Bottle Green", "Cherry Red"],
    size: ["OS"],
    material: "Gloss-finish leather with recycled lining",
    fit: "23 × 19 × 10 cm",
    closure: "Sculptural clasp",
    tags: ["new", "handbag", "top-handle", "glossy"],
  },
  {
    id: 26,
    name: "Suede shopper bag with detachable shoulder strap",
    category: "Bags",
    price: "600.00",
    colors: ["Tobacco Brown", "Forest Green"],
    size: ["OS"],
    material: "Responsibly sourced suede with cotton lining",
    fit: "42 × 32 × 17 cm",
    closure: "Magnetic top closure",
    tags: ["new", "shopper", "suede", "large"],
  },
  {
    id: 27,
    name: "Glossy shoulder baguette bag",
    category: "Bags",
    price: "250.00",
    colors: ["Lacquer Red", "Black"],
    size: ["OS"],
    material: "Gloss-finish recycled faux leather",
    fit: "29 × 14 × 8 cm",
    closure: "Sculptural metal clasp",
    tags: ["new", "shoulder bag", "baguette", "glossy"],
  },
  {
    id: 28,
    name: "Patent-faux leather handbag",
    category: "Bags",
    price: "265.00",
    colors: ["Cobalt Blue", "Bottle Green"],
    size: ["OS"],
    material: "Solvent-free patent faux leather with recycled lining",
    fit: "27 × 20 × 11 cm",
    closure: "Two-way zip",
    tags: ["new", "handbag", "patent", "structured"],
  },
  {
    id: 29,
    name: "Ruffled leather ballerinas",
    category: "Shoes",
    price: "360.00",
    colors: ["Emerald Green", "Cherry Red"],
    size: shoeSizes,
    material: "Leather upper, lining and sole",
    fit: "Fits true to size",
    closure: "Adjustable ankle strap",
    tags: ["new", "ballerina", "ruffled", "leather"],
  },
  {
    id: 30,
    name: "Chunky leather platform sandals with buckle details",
    category: "Shoes",
    price: "445.00",
    colors: ["Oxblood", "Black"],
    size: shoeSizes,
    material: "Leather upper and lining with rubber sole",
    fit: "90 mm heel with a 35 mm platform",
    closure: "Adjustable buckle straps",
    tags: ["new", "sandals", "platform", "leather"],
  },
];

const productData = rawProducts.map((product) => {
  const imageNumber = String(product.id).padStart(2, "0");
  const image = `/img/generated/product-${imageNumber}.jpg`;
  const detailImage = `/img/generated/product-${imageNumber}-detail.jpg`;
  const galleryViews = [3, 4, 5, 6].map(
    (view) => `/img/generated/product-${imageNumber}-view-0${view}.jpg`
  );

  return {
    ...product,
    image,
    images: [image, detailImage, ...galleryViews],
    description: [
      `${product.name} brings a confident, color-forward point of view to everyday dressing. The silhouette is carefully balanced so the statement detail remains easy to wear.`,
      `Crafted in ${product.material.toLowerCase()}, it is finished with considered construction and a clean interior for lasting comfort.`,
    ],
    attributes: {
      fit: product.fit,
      closure: product.closure,
      care: "Check the garment care label for detailed instructions",
      collection: "Seasonal collection",
      reference: `VFH-${String(product.id).padStart(3, "0")}`,
    },
    Features: [
      product.fit,
      product.closure,
      product.material,
      "Selected by Vappyfurhome",
    ],
    reviews: String(18 + product.id * 3),
    rating: (4.4 + (product.id % 5) * 0.1).toFixed(1),
    isNew: product.id <= 24,
  };
});

export const categories = [
  "All",
  "Dresses",
  "Tops & blouses",
  "Sweaters & cardigans",
  "T-shirts & sweatshirts",
  "Pants & shorts",
  "Coats & jackets",
  "Denim",
  "Skirts",
  "Bags",
  "Shoes",
];

export default productData;
